//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    gap: 10px;
    margin: 15px 0;
    align-self: center;
    @media (max-width: 870px) {
        width: unset;
        flex-direction: column;
    }
`;